import { useEffect, useState } from "react";
import { useData } from "../../../context/DataContext";
import { useNavigate, useLocation } from "react-router-dom";
import { addAttendance } from "../../../context/createAPI";
import Chart from 'react-apexcharts';
import LoadingComponent from '../../../components/Loading/LoadingComponent';
import moment from "moment";
import * as XLSX from 'xlsx';
import {
    Box, Card, CardActions, CardContent, Divider, Grid, TextField, CardHeader, Typography, Button, Table,
    TableHead, FormControl, InputLabel, MenuItem, Select,
    TableRow,
    TableCell,
    TableBody,
    Checkbox,
    TableContainer,
    Paper,
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomButton from "../../../components/buttons/customButton";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import DownloadIcon from "@mui/icons-material/Download";
import { APP_ROUTES } from "../../../config/appRoutes";
import { getClientTheme } from "../../../theme/clientTheme";

const TrainingScheduleAttendance = () => {

    const { sessionAttendance, user = {}, handleTrainingSessions, subLoading, levels = [], user_client_id } = useData();
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const clientTheme = getClientTheme(user_client_id);

    const navigate = useNavigate();
    const location = useLocation();
    const { rowData } = location.state || {};
    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [searchFilter, setSearchFilter] = useState("");
    const [attendanceSelections, setAttendanceSelections] = useState([]);
    const [userAttendanceData, setUserAttendanceData] = useState([]);

    const [state, setState] = useState({
        isLoader: false,
    });
    const [selectedIds, setSelectedIds] = useState({
        present: [],
        absent: [],
        notMarked: [],
    });
    const [attendenceDates, setAttendanceDates] = useState([]);
    const [selectedAttendanceDate, setSelectedAttendanceDate] = useState("");
    const [dayWiseData, setDayWiseData] = useState([]);

    const calculateAttendanceCounts = (data) => {
        const counts = { 0: 0, 1: 0, 2: 0 };
        data?.forEach(item => {
            counts[item.attendance_status] += 1;
        });
        return counts;
    };

    const attendanceCounts = calculateAttendanceCounts(sessionAttendance.length > 0 ? sessionAttendance : []);
    const employeesCount = [attendanceCounts[0], attendanceCounts[1], attendanceCounts[2]];

    const chartSeriesDayWise = [dayWiseData[0], dayWiseData[1]];

    const chartOptions = {
        chart: {
            type: 'pie'
        },
        labels: [`Absent ${attendanceCounts[0]}`, `Present ${attendanceCounts[1]}`, `Not Marked ${attendanceCounts[2]}`],
        colors: ['#F44336', '#4CAF50', '#00bbf0'],
        plotOptions: {
            pie: {
                expandOnClick: true,
                donut: {
                    size: '60%'
                }
            }
        }
    };



    const chartOptionsDayWise = {
        chart: {
            type: 'pie'
        },
        labels: [`Absent ${dayWiseData[0]}`, `Present ${dayWiseData[1]}`],
        colors: ['#F44336', '#4CAF50', '#00bbf0'],
        plotOptions: {
            pie: {
                expandOnClick: true,
                donut: {
                    size: '60%'
                }
            }
        }
    };

    const chartSeries = employeesCount;

    useEffect(() => {
        let date = moment(attendenceDates?.find((item) => item.value === parseInt(selectedAttendanceDate, 10))?.label, 'DD-MM-YYYY');
        const startTime = date.startOf('day').unix();
        const endTime = date.endOf('day').unix();
        let filteredData = sessionAttendance.filter((item) => item.attended_date !== null && (item.attended_date > startTime && item.attended_date < endTime));
        const dayWiseAddedCount = calculateAttendanceCounts(filteredData.length > 0 ? filteredData : []);
        setUserAttendanceData(filteredData);

        setDayWiseData(dayWiseAddedCount);

    }, [selectedAttendanceDate, sessionAttendance]);



    useEffect(() => {

        const sessionResults = sessionAttendance.length > 0 ? sessionAttendance.filter((item) => item.attendance_status === 2 || item.attendance_status === 0).map(item => ({
            id: item.id,
            attendance_status: item.attendance_status,
            farmer_name: item.farmer_name,
            relative_name: item.relative_name,
            previous_status: item.attendance_status,
            attended_date: item.attended_date
        })) : [];

        function formatDateToDDMMYYYY(timestamp) {
            const date = new Date(parseInt(timestamp) * 1000);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }


        function getUniqueRecords(data) {
            const uniqueRecords = [];
            data.forEach((record, index) => {
                const date = formatDateToDDMMYYYY(record.attended_date);
                if (!uniqueRecords.some(r => r.label === date)) {
                    uniqueRecords.push({ value: index, label: date });
                }
            });
            return uniqueRecords;
        }

        const uniqueRecords = getUniqueRecords(sessionAttendance.filter((item) => item.attended_date !== null));

        setAttendanceDates(uniqueRecords);
        setSelectedAttendanceDate(uniqueRecords.length > 0 ? uniqueRecords[0].value : "")
        setAttendanceSelections(sessionResults);
    }, [sessionAttendance]);



    const handleCheckboxChange = (id, type) => {

        const updatedSelections = attendanceSelections.map((selection) => {
            if (selection.id === id) {
                const newStatus =
                    type === 'present' ? (selection.attendance_status === 1 ? 2 : 1) :
                        type === 'absent' ? (selection.attendance_status === 0 ? 2 : 0) :
                            (selection.attendance_status === 2 ? 2 : 0);
                return {
                    ...selection,
                    attendance_status: newStatus,
                };
            }
            return selection;
        });

        setAttendanceSelections(updatedSelections);
        updateSelectedIds(updatedSelections);
    };


    const updateSelectedIds = (updatedSelections) => {

        const newSelectedIds = {
            present: [],
            absent: [],
            notMarked: [],
        };

        updatedSelections.forEach((selection) => {
            if (selection.attendance_status === 1) newSelectedIds.present.push({ id: selection.id, attendance_status: selection.attendance_status, previous_status: selection.previous_status, attended_date: selection.attended_date });
            if (selection.attendance_status === 0) newSelectedIds.absent.push({ id: selection.id, attendance_status: selection.attendance_status, previous_status: selection.previous_status, attended_date: selection.attended_date });
            if (selection.attendance_status === 2) newSelectedIds.notMarked.push({ id: selection.id, attendance_status: selection.attendance_status, previous_status: selection.previous_status, attended_date: selection.attended_date });
        });
        setSelectedIds(newSelectedIds);
    };


    // const totalPages = Math.ceil(attendanceSelections.filter(item => item.id.toString().toLowerCase().includes(searchFilter)).length / itemsPerPage);

    // const handleNextPage = () => { if (currentPage < totalPages) { setCurrentPage((prevPage) => prevPage + 1); } };

    // const handlePrevPage = () => { if (currentPage > 1) { setCurrentPage((prevPage) => prevPage - 1); } };

    const handleSearch = (e) => {
        const searchValue = e.target.value.toLowerCase();
        setSearchFilter(searchValue);
        setCurrentPage(1);
    };

    const handleAttendanceSubmit = async () => {

        const mergedAttendanceArr = [...selectedIds.present, ...selectedIds.absent, ...selectedIds.notMarked];

        setState((prevState) => ({ ...prevState, isLoader: true }));
        if (mergedAttendanceArr.length === 0) {
            setTimeout(() => {
                navigate(-1);
            }, 1000);
        }

        const modifiedData = mergedAttendanceArr.map((item) => {

            if (item.previous_status === 2 && (parseInt(item.previous_status) !== parseInt(item.attendance_status, 10))) {
                return {
                    attendance_status: item.attendance_status,
                    id: item.id,
                    attended_date: Math.floor(Date.now() / 1000)
                };
            } else {
                return {
                    attendance_status: item.attendance_status,
                    id: item.id,
                    attended_date: item.attended_date !== undefined ? item.attended_date : null
                };
            }
        });

        if (modifiedData.length > 0) {
            try {

                const params = {
                    "training_session_id": rowData?.id ? rowData?.id : null,
                    "farmersData": modifiedData ? modifiedData : [],
                    "inserted_by": user.user_id ? user.user_id : null
                };

                const createSession = await addAttendance(params);
                if (createSession.statusCode === 200) {
                    handleTrainingSessions();
                    setState((prevState) => ({
                        ...prevState,
                        loading: false,
                        responseMessage: createSession.message
                    }));
                    setTimeout(() => {
                        navigate(-1);
                    }, 1000);


                    setSnackbar({
                        open: true,
                        message: createSession.message,
                        severity: "success",
                    });
                }
            } catch (error) {
                console.error(error);
                setSnackbar({
                    open: true,
                    message: error,
                    severity: "success",
                });
            }
        } else {
            setTimeout(() => {
                navigate(APP_ROUTES.TRAININGSESSION.HISTORY);
            }, 1000);
            setSnackbar({
                open: true,
                message: "The changes have not been updated",
                severity: "success",
            });
        }
    }


    const handleInputChange = (e) => {
        setSelectedAttendanceDate(e.target.value)
    }

    if (subLoading || !sessionAttendance || sessionAttendance.length === 0) {
        return <LoadingComponent />;
    }


    const searchFilterFarmerArr = attendanceSelections.filter(item => (item.farmer_name.toLowerCase() || item.relative_name.toLowerCase()).includes(searchFilter))

    const handleExcelDownload = (type) => {

        let formattedData = [];

        if (type === "overAllAttendace") {
            formattedData = sessionAttendance.map((item, index) => ({
                sno: index + 1,
                farmer_name: item.farmer_name !== null ? item.farmer_name : "-",
                attendance_status:
                    item.attendance_status !== null
                        ? item.attendance_status === 0
                            ? "Absent"
                            : item.attendance_status === 1
                                ? "Present"
                                : "Not Marked"
                        : "-",
                attended_date: item.attended_date ? moment.unix(item.attended_date).format("DD/MM/YYYY") : "-",
            }));
        } else {
            formattedData = userAttendanceData.map((item, index) => ({
                sno: index + 1,
                farmer_name: item.farmer_name !== null ? item.farmer_name : "-",
                attendance_status:
                    item.attendance_status !== null
                        ? item.attendance_status === 0
                            ? "Absent"
                            : item.attendance_status === 1
                                ? "Present"
                                : "Not Marked"
                        : "-",
                attended_date: item.attended_date ? moment.unix(item.attended_date).format("DD/MM/YYYY") : "-",
            }));
        }

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, 'AttendaceReports.xlsx');
    };

    return (
        <Box>
            <Card elevation={6}>


                <CardContent>


                    <Box
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <CustomButton
                            label="Back"
                            status={false}
                            onClick={() => navigate(-1)}
                            icon={<ArrowBackIcon />}
                        />
                    </Box>

                    <Divider sx={{ my: 1, bgcolor: '#f5f1f1ff' }} />

                    <Grid container spacing={1}>
                        <Grid item size={{ xs: 12, md: 4 }}>
                            <Card elevation={6} sx={{ height: "100%" }}>
                                <CardHeader
                                    title="Session Attendance"
                                    titleTypographyProps={{
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                        align: "center",
                                    }}
                                />

                                <CardContent
                                    sx={{
                                        textAlign: "center",
                                        p: 2,
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        fontWeight="bold"
                                        gutterBottom
                                    >
                                        Overall
                                    </Typography>

                                    <Chart
                                        options={chartOptions}
                                        series={chartSeries}
                                        type="donut"
                                        height={190}
                                    />


                                    {
                                        attendenceDates.length > 0 && (
                                            <Box>
                                                {/* HEADER + SELECT */}
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item size={{ xs: 12, md: 6 }}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            fontWeight="bold"
                                                            textAlign="center"
                                                        >
                                                            Day Wise
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item size={{ xs: 12, md: 6 }}>
                                                        <FormControl fullWidth size="small">
                                                            <InputLabel id="attendance-date-label">
                                                                Attendance Date
                                                            </InputLabel>

                                                            <Select
                                                                labelId="attendance-date-label"
                                                                id="single-select"
                                                                value={selectedAttendanceDate}
                                                                label="Attendance Date"
                                                                onChange={(e) => handleInputChange(e)}
                                                                name="attendanceDate"
                                                            >
                                                                {attendenceDates?.map((item) => (
                                                                    <MenuItem key={item.value} value={item.value}>
                                                                        {item.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>

                                                    </Grid>
                                                </Grid>

                                                {/* DONUT CHART */}
                                                <Box mt={2} display="flex" justifyContent="center">
                                                    <Chart
                                                        options={chartOptionsDayWise}
                                                        series={chartSeriesDayWise}
                                                        type="donut"
                                                        height={190}
                                                    />
                                                </Box>
                                            </Box>
                                        )
                                    }
                                </CardContent>
                                {
                                    attendenceDates.length > 0 && (
                                        <CardActions
                                            sx={{
                                                px: 2,
                                                pb: 2,
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Grid
                                                container
                                                spacing={2}
                                                justifyContent="center"
                                                alignItems="center"
                                            >
                                                <Grid item xs={12} md={6} textAlign="center">
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        color="success"
                                                        sx={{ backgroundColor: clientTheme.activeBg, }}
                                                        startIcon={<DownloadIcon />}
                                                        onClick={() => handleExcelDownload("overAllAttendace")}
                                                    >
                                                        Overall Excel
                                                    </Button>
                                                </Grid>

                                                <Grid item xs={12} md={6} textAlign="center">
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ backgroundColor: clientTheme.activeBg, }}
                                                        startIcon={<DownloadIcon />}
                                                        onClick={() => handleExcelDownload("dayWiseAttendace")}
                                                    >
                                                        Day-Wise Excel
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </CardActions>
                                    )
                                }

                            </Card>
                        </Grid>


                        <Grid item size={{ xs: 12, md: 8 }}>
                            <CardHeader
                                title={
                                    <Grid container spacing={1}>
                                        <Grid item size={{ xs: 12, md: 6 }}>
                                            <TextField type="text" placeholder="Search..." onChange={handleSearch} value={searchFilter} size="small" fullWidth />
                                        </Grid>
                                    </Grid>
                                }
                                titleTypographyProps={{
                                    fontWeight: "bold",
                                    textTransform: "uppercase",
                                }}
                            />

                            <CardContent >
                                <TableContainer component={Paper} sx={{
                                    boxShadow: 6,
                                    maxHeight: "60vh",
                                    overflowY: "auto",          // vertical scroll
                                    overflowX: { xs: "auto", md: "hidden" }, // horizontal scroll only on mobile
                                    WebkitOverflowScrolling: "touch", // smooth mobile scroll
                                }}>
                                    <Table size="small"  >
                                        <TableHead sx={{
                                            backgroundColor: clientTheme.activeBg,
                                        }}>
                                            <TableRow>
                                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                    Sno
                                                </TableCell>
                                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                    Name
                                                </TableCell>
                                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                    Father Name
                                                </TableCell>
                                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                    P
                                                </TableCell>
                                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                    A
                                                </TableCell>
                                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                    NM
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchFilterFarmerArr.map((item, index) => (
                                                <TableRow key={item.id} hover>
                                                    <TableCell align="center">
                                                        {(currentPage - 1) * itemsPerPage + index + 1}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {item.farmer_name || "-"}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {item.relative_name || "-"}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Checkbox
                                                            checked={item.attendance_status === 1}
                                                            onChange={() => handleCheckboxChange(item.id, "present")}
                                                            color="success"
                                                        />
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Checkbox
                                                            checked={item.attendance_status === 0}
                                                            onChange={() => handleCheckboxChange(item.id, "absent")}
                                                            color="error"
                                                        />
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Checkbox
                                                            checked={item.attendance_status === 2}
                                                            onChange={() => handleCheckboxChange(item.id, "notMarked")}
                                                            color="warning"
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>

                            <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                                <CustomButton
                                    status={state.isLoader === true ? "loading" : "idle"}
                                    onClick={handleAttendanceSubmit}
                                    label="Submit"
                                    loadingLabel="Submitting.."
                                />

                            </CardActions>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    );
};
export default TrainingScheduleAttendance;